import { Pipe, PipeTransform } from '@angular/core';
import { Patterns, Social, SocialKeys } from '@ag-common-lib/public-api';

@Pipe({ name: 'socialNameFromUrl' })
export class SocialNameFromUrlPipe implements PipeTransform {
  transform(data: Social): string {
    const socialMedia = data?.[SocialKeys.socialMedia];
    const userName = data?.[SocialKeys.accountId];
    const url = data?.url;
    if (!url) {
      return '';
    }

    if (['YT', 'TW', 'TT'].includes(socialMedia) && userName?.charAt(0) === '@') {
      // for YouTube, Twitter, and TikTok = remove first @
      return userName.slice(1);
    }

    const last = this.getLastSegmentOfUrl(url);
    if (socialMedia === 'TT' && last?.charAt(0) === '@') {
      return last.slice(1);
    }
    return last ?? url.replace(Patterns.URL_PATTERN_WWW, '').replace(Patterns.TRAILING_SLASHES_PATTERN, '');
  }

  getLastSegmentOfUrl = (url: string) => {
    const segments = new URL(this.normalizeUrl(url)).pathname.split('/').filter(Boolean);
    return segments.pop() || segments.pop(); // Handle trailing slash
  };

  normalizeUrl = (url: string) => {
    const regExp = Patterns.URL_PATTERN_PROTOCOL_REGEXP as RegExp;
    const isValidUrl = regExp.test(url);
    return isValidUrl ? url : `http://${url}`;
  };
}
